import { day } from "./time";
//TODO: move this out of here, this is not a filter
export function getEmployeeSortProp(sortProperty) {
    return (employee) => {
        switch (sortProperty) {
            case "birthdayDate":
                return employee.birthday?.slice(5) || "";
            case "contractEnd": {
                const latestContract = employee.latestContract;
                return latestContract ? latestContract?.end || "9999-12-31" : "0000-00-00";
            }
            case "employedDays": {
                const employedInterval = employee.employedInterval;
                if (!employedInterval) {
                    return 0;
                }
                else {
                    const diff = employedInterval[1].getTime() - employedInterval[0].getTime();
                    return diff >= 0 ? diff + 1 * day : 0; // add one day to account for the day of end date, ignore negative intervals
                }
            }
            default: {
                const value = employee[sortProperty];
                if (typeof value === "string") {
                    return value.trim();
                }
                else if (typeof value === "number") {
                    return value;
                }
                return "";
            }
        }
    };
}
//# sourceMappingURL=sorting.js.map